<template>
  <b-container fluid>
    <b-row class="my-3">
      <b-col class="d-flex">
        <a-month-picker
          v-model="dateStart"
          @change="changeDateStart"
          placeholder="Месяц с"
          format="MM/YYYY"
          size="large"
          name="input-1"
          class="mx-3"
        />
        <a-month-picker
          v-model="dateEnd"
          @change="changeDateEnd"
          placeholder="Месяц по"
          format="MM/YYYY"
          size="large"
          name="input-2"
          class="mx-3"
        />
        <b-button
          class="b-report mx-3"
          variant="success"
          @click="setItems"
          :disabled="disableButton"
          type="button"
        >
          Загрузить отчет
        </b-button>
      </b-col>
    </b-row>

    <b-row v-if="salesStatistic">
      <b-col md="4" lg="3">
        <b-form-select
          v-model="filterOptions.selectedDealer"
          :options="salesStatistic"
          value-field="id"
          text-field="name"
          class="m-3"
        >
          <template #first>
            <b-form-select-option :value="-1" disabled>
              Выберите дилера
            </b-form-select-option>
          </template>
          <b-form-select-option :value="null" v-if="salesStatistic.length > 1">
            Все дилеры
          </b-form-select-option>
        </b-form-select>
      </b-col>
      <b-col md="4" lg="3">
        <div class="search m-3">
          <b-form-input
            v-model="filterOptions.searchFilter"
            @input="handleSearchInput"
            placeholder="Поиск"
          />
          <div class="container_search-close" @click="clearField">
            <span class="search-close">&#215;</span>
          </div>
        </div>
      </b-col>
      <b-col md="4" lg="6" class="button-end">
        <b-button
          v-if="isActiveClientWithoutOrgId()"
          @click="downloadActiveClientsWithoutOrgIdReport"
          variant="outline-success"
          class="my-3 mx-1"
        >
          <b-spinner v-if="visible" small type="grow" class="mr-3"></b-spinner>
          Активные клиенты без Org_ID
        </b-button>
        <b-button
          v-if="isPickUgUser()"
          @click="downloadXml"
          variant="outline-success"
          class="my-3 mx-1"
        >
          Выгрузить в XML
        </b-button>
        <b-dropdown
          v-if="isProminvestUser()"
          right
          variant="success"
          class="my-3 mx-1"
        >
          <template v-slot:button-content>
            Отчёт для КП
          </template>
          <b-dropdown-item
            v-for="dealer in salesStatistic"
            @click="downloadXlsxClientProgram(dealer.id, dealer.name)"
            :key="dealer.id"
          >
            <p class="mb-0 download-report">
              {{ dealer.name }} <i class="fas fa-file-download"></i>
            </p>
          </b-dropdown-item>
        </b-dropdown>
        <b-dropdown right variant="success" class="my-3 mx-1">
          <template v-slot:button-content>
            Выгрузить в Excel
          </template>
          <b-dropdown-item @click="downloadXlsx(null, null)">
            <p class="mb-0 download-report">
              Отфильтрованные записи <i class="fas fa-file-download ml-1"></i>
            </p>
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item
            v-for="dealer in salesStatistic"
            @click="downloadXlsx(dealer.dealer_org_id, dealer.name)"
            :key="dealer.id"
          >
            <p class="mb-0 download-report">
              {{ dealer.name }} <i class="fas fa-file-download ml-1"></i>
            </p>
          </b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>

    <b-row v-if="salesStatistic">
      <b-col>
        <b-card bg-variant="light" class="m-3">
          <b-row>
            <b-col>
              <span v-if="filterOptions.selectedDealer !== null" style="font-family: 'PT Root UI Bold', Tahoma, Geneva, Verdana, sans-serif">{{ selectedDealerName }}</span>
              <span v-else style="font-family: 'PT Root UI Bold', Tahoma, Geneva, Verdana, sans-serif">
                Все дилеры
              </span>
            </b-col>
            <b-col style="font-family: 'PT Root UI Bold', Tahoma, Geneva, Verdana, sans-serif">
              <p class="info-text">Всего пакетов:</p>
              <p class="total">
                {{ totalPackagesValue }}
                <b-button
                  id="popover-1"
                  size="sm"
                  variant="light"
                  v-if="filterOptions.selectedDealer !== null"
                >
                  <i class="fas fa-caret-down"></i>
                </b-button>
              </p>
            </b-col>
            <b-col style="font-family: 'PT Root UI Bold', Tahoma, Geneva, Verdana, sans-serif">
              <p class="info-text">Всего активных клиентов:</p>
              <p class="total">{{ totalActiveClientsValue }}</p>
            </b-col>
            <b-col style="font-family: 'PT Root UI Bold', Tahoma, Geneva, Verdana, sans-serif">
              <p class="info-text">Итого к уплате клиентами:</p>
              <p class="total">{{ totalCostValue }} руб.</p>
            </b-col>
            <b-col style="font-family: 'PT Root UI Bold', Tahoma, Geneva, Verdana, sans-serif">
              <p class="info-text">Итого к уплате {{ totalUpdealerName }}:</p>
              <p class="total">{{ totalUpdealerCostValue }} руб.</p>
            </b-col>
            <b-col style="font-family: 'PT Root UI Bold', Tahoma, Geneva, Verdana, sans-serif">
              <p class="info-text">Итого к уплате Даобит:</p>
              <p class="total">{{ totalOrgCostValue }} руб.</p>
            </b-col>
            <b-popover
              v-if="filterOptions.selectedDealer !== null"
              target="popover-1"
              placement="bottom"
              triggers="click"
            >
              <ul class="w-100">
                <li
                  class="positions-elements"
                  v-for="position in totalPackagesTable"
                  :key="position.count"
                >
                  {{ position.name }} - {{ position.count }}
                </li>
              </ul>
            </b-popover>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row v-if="salesStatistic">
      <b-col class="ml-3">
        <small>
          <p v-if="filterOptions.selectedDealer !== null">
            Отфильтровано записей {{ visibleDealerItems.length }} из {{ filteredItemsCount }}
          </p>
          <p v-else>
            Отфильтровано дилеров {{ filteredDealers.length }} из {{ salesStatistic.length }}
          </p>
        </small>
      </b-col>
    </b-row>

    <!-- Таблица для выбранного дилера -->
    <b-row v-if="filterOptions.selectedDealer !== null">
      <b-col>
        <div class="virtual-table-container" @scroll="handleDealerTableScroll">
          <b-table-simple hover small bordered responsive class="p-3">
            <b-thead>
              <b-tr>
                <b-th v-for="field in dealerFields" :key="field.key">{{ field.label }}</b-th>
              </b-tr>
            </b-thead>
            <b-tbody v-for="(client, index) in visibleDealerItems" :key="'client-' + index">
              <b-tr v-for="(position, key) in positionsData(client)" :key="'position-' + key">
                <b-th :rowspan="positionsData(client).length" v-if="key === 0">
                  <p class="mb-0"><b>{{ client.name }}</b></p>
                  <small><p class="mb-1">{{ client.inn }} / {{ client.kpp }}</p></small>
                  <small v-if="client.contract_number && client.contract_date">
                    <p class="mb-1">{{ client.contract_number }} / {{ client.contract_date }}</p>
                  </small>
                  <p v-if="client.client_org_id" class="mt-2" style="font-weight: 400;">
                    org_id: {{ client.client_org_id }}
                  </p>
                </b-th>
                <b-td
                  v-if="Object.values(position)[0].ind === 0"
                  :rowspan="Object.keys(client.positions[Object.keys(position)[0]]).length"
                  class="monthColumn"
                >
                  {{ Object.keys(position)[0] }}
                </b-td>
                <b-td v-if="Object.values(position)[0].name">
                  {{ Object.values(position)[0].name }}
                </b-td>
                <b-td
                  :colspan="!Object.values(position)[0].name ? 3 : 1"
                  :class="!Object.values(position)[0].name ? 'total text-right' : ''"
                >
                  {{ Object.values(position)[0].count }}
                </b-td>
                <b-td :class="!Object.values(position)[0].name ? 'total text-right' : ''">
                  {{ Object.values(position)[0].cost }}
                </b-td>
                <b-td :class="!Object.values(position)[0].name ? 'total text-right' : ''">
                  {{ Object.values(position)[0].daobit_cost }}
                </b-td>
                <b-td>
                  {{ Object.values(position)[0].comment }}
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>

          <div v-if="visibleDealerItems.length < filteredItemsCount" class="loading-more">
            <b-button @click="loadMoreDealerItems" variant="outline-primary" size="small">
              Загрузить еще ({{ visibleDealerItems.length }}/{{ filteredItemsCount }})
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- Аккордеон для всех дилеров -->
    <b-row v-else>
      <b-col>
        <div v-if="salesStatistic && filteredDealers.length > 0">
          <div v-for="(dealer) in filteredDealers" :key="dealer.id" class="mb-3">
            <b-card
              :id="'dealerCard-' + dealer.id"
              @click="() => toggleDealerCard(dealer.id)"
              bg-variant="light"
              :class="{ 'card-expanded': expandedDealers[dealer.id] }"
            >
              <b-row style="cursor: pointer;">
                <b-col>
                  <span style="font-family: 'PT Root UI Bold', Tahoma, Geneva, Verdana, sans-serif">
                    {{ dealer.name }}
                  </span>
                </b-col>

                <b-col>
                  <p class="info-text">Всего пакетов:</p>
                  <p class="total">{{ dealer.total_packages }}</p>
                </b-col>
                <b-col>
                  <p class="info-text">Всего активных клиентов:</p>
                  <p class="total">
                    {{ getDisplayedClientsCount(dealer) }}
                    <span v-if="filterOptions.searchFilter && dealer.hasSearchMatches"
                          class="text-success small">
                      (совпадений&nbsp;{{ dealer.filteredClients.length }})
                    </span>
                  </p>
                </b-col>
                <b-col>
                  <p class="info-text">Итого к уплате клиентами:</p>
                  <p class="total">{{ dealer.total_cost }} руб.</p>
                </b-col>
                <b-col>
                  <p class="info-text">Итого к уплате {{ dealer.updealer_name }}:</p>
                  <p class="total">{{ dealer.updealer_cost }} руб.</p>
                </b-col>
                <b-col>
                  <p class="info-text">Итого к уплате Даобит:</p>
                  <p class="total">{{ dealer.daobit_cost }} руб.</p>
                </b-col>
              </b-row>

              <b-collapse :visible="expandedDealers[dealer.id]">
                <div @click.stop>
                  <div v-if="shouldShowDealerClients(dealer)"
                       class="virtual-table-container mt-3"
                       @scroll="(e) => handleDealerClientScroll(e, dealer.id)">
                    <b-table-simple style="background: #ffffff !important;" hover small bordered responsive class="dealer-clients">
                      <b-thead>
                        <b-tr>
                          <b-th v-for="field in dealerFields" :key="field.key">{{ field.label }}</b-th>
                        </b-tr>
                      </b-thead>
                      <b-tbody v-for="(client, clientIndex) in getDealerVisibleItems(dealer.id)" :key="'client-' + clientIndex">
                        <b-tr v-for="(position, key) in positionsData(client)" :key="'position-' + key">
                          <b-th :rowspan="positionsData(client).length" v-if="key === 0">
                            <p class="mb-0"><b>{{ client.name }}</b></p>
                            <small><p class="mb-1">{{ client.inn }} / {{ client.kpp }}</p></small>
                            <small v-if="client.contract_number && client.contract_date">
                              <p class="mb-1">{{ client.contract_number }} / {{ client.contract_date }}</p>
                            </small>
                            <p v-if="client.client_org_id" class="mt-2" style="font-weight: 400;">
                              org_id: {{ client.client_org_id }}
                            </p>
                          </b-th>
                          <b-td
                            v-if="Object.values(position)[0].ind === 0"
                            :rowspan="Object.keys(client.positions[Object.keys(position)[0]]).length"
                            class="monthColumn"
                          >
                            {{ Object.keys(position)[0] }}
                          </b-td>
                          <b-td v-if="Object.values(position)[0].name">
                            {{ Object.values(position)[0].name }}
                          </b-td>
                          <b-td
                            :colspan="!Object.values(position)[0].name ? 3 : 1"
                            :class="!Object.values(position)[0].name ? 'total text-right' : ''"
                          >
                            {{ Object.values(position)[0].count }}
                          </b-td>
                          <b-td :class="!Object.values(position)[0].name ? 'total text-right' : ''">
                            {{ Object.values(position)[0].cost }}
                          </b-td>
                          <b-td :class="!Object.values(position)[0].name ? 'total text-right' : ''">
                            {{ Object.values(position)[0].daobit_cost }}
                          </b-td>
                          <b-td>
                            {{ Object.values(position)[0].comment }}
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>

                    <div v-if="getDealerVisibleItems(dealer.id).length < getTotalClientsCount(dealer)" class="loading-more">
                      <b-button @click="() => loadMoreDealerClientItems(dealer.id)" variant="outline-primary" size="small">
                        Загрузить еще ({{ getDealerVisibleItems(dealer.id).length }}/{{ getTotalClientsCount(dealer) }})
                      </b-button>
                    </div>
                  </div>
                  <div class="text-center mt-2 mb-2" v-else-if="dealer.clients.length === 0">
                    У дилера нет клиентов
                  </div>
                  <div class="text-center mt-2 mb-2" v-else>
                    У дилера нет клиентов, соответствующих поисковому запросу
                  </div>
                </div>
              </b-collapse>
            </b-card>
          </div>
        </div>
        <div v-else-if="salesStatistic" class="text-center mt-5">
          <p>Нет дилеров, соответствующих поисковому запросу</p>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'statistic',
  data () {
    return {
      loading: false,
      dealerFields: [
        { key: 'organization', label: 'Организация' },
        { key: 'months', label: 'Месяц' },
        { key: 'service', label: 'Услуги' },
        { key: 'quantity', label: 'Кол-во' },
        { key: 'amount', label: 'Сумма' },
        { key: 'daobit', label: 'Даобит' },
        { key: 'comments', label: 'Комментарий' }
      ],
      dateStart: null,
      dateEnd: null,
      dateForReport: {
        dateStart: null,
        dateEnd: null,
        dateString: null
      },
      filterOptions: {
        searchFilter: null,
        selectedDealer: null
      },
      totalPackagesValue: 0,
      totalActiveClientsValue: 0,
      totalCostValue: 0,
      totalOrgCostValue: 0,
      totalUpdealerCostValue: 0,
      totalUpdealerName: '',
      totalPackagesTable: [],
      disableButton: true,
      selectedMonth: null,
      selectedYear: null,

      // Состояние раскрытых карточек дилеров
      expandedDealers: {},

      // Виртуализация для таблицы выбранного дилера
      visibleDealerItems: [],
      dealerItemsPerPage: 20,
      dealerCurrentPage: 1,

      // Виртуализация для клиентов в карточках дилеров
      dealerClientsData: {},
      dealerClientsPerPage: 20,
      dealerClientsCurrentPages: {},

      // Кэширование
      processedClientsCache: new Map(),
      searchCache: new Map(),

      selectedDealerName: null,

      // Отфильтрованные дилеры для поиска
      filteredDealers: []
    }
  },
  computed: {
    ...mapState({
      salesStatisticClients: state => state.statistic.salesStatisticClients,
      salesStatistic: state => state.statistic.salesStatistic,
      totalPackages: state => state.statistic.totalPackages,
      totalCost: state => state.statistic.totalCost,
      totalOrgCost: state => state.statistic.totalOrgCost,
      totalUpdealerCost: state => state.statistic.totalUpdealerCost,
      totalActiveClients: state => state.statistic.totalActiveClients,
      dealerId: state => state.authorization.userInfo.company.org_id,
      userInfo: state => state.authorization.userInfo,
      visible: state => state.statistic.visible
    }),

    filteredItemsCount () {
      return this.filteredItems.length
    },

    filteredItems () {
      const cacheKey = `${this.filterOptions.searchFilter}-${this.filterOptions.selectedDealer}`
      if (this.searchCache.has(cacheKey)) {
        return this.searchCache.get(cacheKey)
      }

      if (!this.salesStatisticClients || !Array.isArray(this.salesStatisticClients)) {
        return []
      }

      let filtered = [...this.salesStatisticClients]

      if (this.filterOptions.searchFilter) {
        const searchTerm = this.filterOptions.searchFilter.toLowerCase()
        filtered = filtered.filter(item => {
          if (!searchTerm) return true

          // Базовые поля организации
          if (
            item?.name?.toLowerCase().includes(searchTerm) ||
            item?.inn?.toLowerCase().includes(searchTerm) ||
            item?.kpp?.toLowerCase().includes(searchTerm) ||
            item?.contract_number?.toLowerCase().includes(searchTerm) ||
            (item?.client_org_id && item.client_org_id.toString().includes(searchTerm))
          ) {
            return true
          }

          // Поиск по позициям (positions)
          if (item.positions) {
            for (const month in item.positions) {
              const monthPositions = item.positions[month]
              for (const positionKey in monthPositions) {
                const position = monthPositions[positionKey]

                // Поиск по всем текстовым полям позиции
                if (
                  position?.name?.toLowerCase().includes(searchTerm) ||
                  position?.comment?.toLowerCase().includes(searchTerm) ||
                  position?.tracked_pairs?.toLowerCase().includes(searchTerm)
                ) {
                  return true
                }

                // Поиск по ключам позиций (например: "tpp_dynamic_standard", "pp_oez_poez_toser")
                if (positionKey.toLowerCase().includes(searchTerm)) {
                  return true
                }
              }
            }
          }

          return false
        })
      }

      if (this.filterOptions.selectedDealer !== null) {
        filtered = filtered.filter(item => item?.dealer_id === this.filterOptions.selectedDealer)
      }

      this.searchCache.set(cacheKey, filtered)
      return filtered
    }
  },
  watch: {
    salesStatisticClients: {
      immediate: true,
      handler () {
        this.processedClientsCache.clear()
        this.searchCache.clear()
        this.dealerCurrentPage = 1
        this.updateVisibleDealerItems()
      }
    },

    filterOptions: {
      deep: true,
      handler () {
        if (this.filterOptions.selectedDealer !== null) {
          this.dealerCurrentPage = 1
          this.updateVisibleDealerItems()
        } else {
          this.applyDealerSearch()
        }
      }
    },

    'filterOptions.selectedDealer' (newVal) {
      if (newVal !== null) {
        const dealer = this.salesStatistic.find(item => item.id === newVal)
        if (dealer) {
          this.totalPackagesValue = dealer.total_packages
          this.totalPackagesTable = dealer.positions || []
          this.totalCostValue = dealer.total_cost
          this.totalOrgCostValue = dealer.daobit_cost
          this.totalUpdealerCostValue = dealer.updealer_cost
          this.totalUpdealerName = dealer.updealer_name
          this.totalActiveClientsValue = dealer.clients?.length || 0
          this.selectedDealerName = dealer.name
        }
      } else {
        this.totalPackagesValue = this.totalPackages
        this.totalCostValue = this.totalCost
        this.totalOrgCostValue = this.totalOrgCost
        this.totalUpdealerCostValue = this.totalUpdealerCost
        this.totalActiveClientsValue = this.totalActiveClients
        this.totalUpdealerName = ''
        this.totalPackagesTable = []
        this.selectedDealerName = null
        this.applyDealerSearch()
      }
    },

    salesStatistic: {
      immediate: true,
      handler (newVal) {
        if (newVal && Array.isArray(newVal)) {
          if (newVal.length === 1) {
            this.filterOptions.selectedDealer = newVal[0].id
          } else {
            this.filteredDealers = [...newVal]
          }
        }
      }
    },

    totalPackages () {
      if (this.filterOptions.selectedDealer === null) {
        this.totalPackagesValue = this.totalPackages
      }
    },

    totalCost () {
      if (this.filterOptions.selectedDealer === null) {
        this.totalCostValue = this.totalCost
      }
    },

    totalOrgCost () {
      if (this.filterOptions.selectedDealer === null) {
        this.totalOrgCostValue = this.totalOrgCost
      }
    },

    totalActiveClients () {
      if (this.filterOptions.selectedDealer === null) {
        this.totalActiveClientsValue = this.totalActiveClients
      }
    },

    dateStart () {
      this.disableButton = this.dateStart === null
    }
  },
  created () {
    this.handleSearchInput = debounce(() => {
      if (this.filterOptions.selectedDealer !== null) {
        this.updateVisibleDealerItems()
      } else {
        this.applyDealerSearch()
      }
    }, 300)
  },
  beforeDestroy () {
    this.clearStatistic()
  },
  methods: {
    getDisplayedClientsCount (dealer) {
      if (this.filterOptions.searchFilter && dealer.filteredClients) {
        return dealer.filteredClients.length
      }
      return dealer.clients ? dealer.clients.length : 0
    },

    getTotalClientsCount (dealer) {
      if (this.filterOptions.searchFilter && dealer.filteredClients) {
        return dealer.filteredClients.length
      }
      return dealer.clients ? dealer.clients.length : 0
    },

    shouldShowDealerClients (dealer) {
      if (this.filterOptions.searchFilter) {
        return dealer.filteredClients && dealer.filteredClients.length > 0
      }
      return dealer.clients && dealer.clients.length > 0
    },

    applyDealerSearch () {
      if (!this.salesStatistic) return

      const searchTerm = this.filterOptions.searchFilter?.toLowerCase().trim()
      const newExpandedDealers = {}

      if (!searchTerm || searchTerm.length < 3) {
        // Сбрасываем поиск - показываем всех дилеров и закрываем все карточки
        this.filteredDealers = this.salesStatistic.map(dealer => ({
          ...dealer,
          filteredClients: null,
          hasSearchMatches: false
        }))
        this.expandedDealers = {}
      } else {
        // Ищем совпадения
        this.filteredDealers = this.salesStatistic.map(dealer => {
          const filteredClients = dealer.clients.filter(client => {
            const searchTerm = this.filterOptions.searchFilter?.toLowerCase()
            if (!searchTerm) return true

            // Базовые поля клиента
            if (
              client?.name?.toLowerCase().includes(searchTerm) ||
              client?.inn?.toLowerCase().includes(searchTerm) ||
              client?.kpp?.toLowerCase().includes(searchTerm) ||
              client?.contract_number?.toLowerCase().includes(searchTerm) ||
              (client?.client_org_id && client.client_org_id.toString().includes(searchTerm))
            ) {
              return true
            }

            // Поиск по позициям (positions) клиента
            if (client.positions) {
              for (const month in client.positions) {
                const monthPositions = client.positions[month]
                for (const positionKey in monthPositions) {
                  const position = monthPositions[positionKey]

                  // Поиск по всем текстовым полям позиции
                  if (
                    position?.name?.toLowerCase().includes(searchTerm) ||
                    position?.comment?.toLowerCase().includes(searchTerm) ||
                    position?.tracked_pairs?.toLowerCase().includes(searchTerm)
                  ) {
                    return true
                  }

                  // Поиск по ключам позиций
                  if (positionKey.toLowerCase().includes(searchTerm)) {
                    return true
                  }
                }
              }
            }

            return false
          })

          const hasSearchMatches = filteredClients.length > 0

          // Автоматически раскрываем карточки с совпадениями
          if (hasSearchMatches) {
            newExpandedDealers[dealer.id] = true
            // Сбрасываем пагинацию для этого дилера
            this.$set(this.dealerClientsCurrentPages, dealer.id, 1)
            this.updateDealerClientItems(dealer.id)
          }

          return {
            ...dealer,
            filteredClients: hasSearchMatches ? filteredClients : null,
            hasSearchMatches
          }
        })

        this.expandedDealers = newExpandedDealers
      }
    },

    toggleDealerCard (dealerId) {
      this.$set(this.expandedDealers, dealerId, !this.expandedDealers[dealerId])

      // Если карточка раскрывается, загружаем данные и прокручиваем к ней
      if (this.expandedDealers[dealerId]) {
        this.$set(this.dealerClientsCurrentPages, dealerId, 1)
        this.updateDealerClientItems(dealerId)

        // Прокрутка к карточке после обновления DOM
        setTimeout(() => {
          this.scrollToDealerCard(dealerId)
        }, 500)
      }
    },

    scrollToDealerCard (dealerId) {
      const cardElement = document.getElementById(`dealerCard-${dealerId}`)
      if (cardElement) {
        // Получаем позицию элемента относительно viewport
        const rect = cardElement.getBoundingClientRect()

        // Вычисляем смещение для плавной прокрутки
        const offset = 20 // Небольшой отступ от верха

        // Прокручиваем к элементу с плавной анимацией
        window.scrollTo({
          top: window.scrollY + rect.top - offset,
          behavior: 'smooth'
        })

        // Альтернативный вариант для контейнеров с внутренней прокруткой
        // cardElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    },

    positionsData (client) {
      if (!client || !client.positions) return []

      const cacheKey = `${client.id}-${JSON.stringify(client.positions)}`
      if (this.processedClientsCache.has(cacheKey)) {
        return this.processedClientsCache.get(cacheKey)
      }

      const obj = JSON.parse(JSON.stringify(client.positions))
      const arr = []
      for (const key in obj) {
        let i = 0
        for (const itemKey in obj[key]) {
          obj[key][itemKey].ind = i
          obj[key][itemKey].month = key
          arr.push({ [key]: obj[key][itemKey] })
          i++
        }
        if (client.total_cost && client.daobit_cost) {
          arr.push(
            {
              [key]: {
                name: false,
                count: 'Итого:',
                cost: client.total_cost[key],
                daobit_cost: client.daobit_cost[key],
                comment: ''
              }
            }
          )
        }
      }

      this.processedClientsCache.set(cacheKey, arr)
      return arr
    },

    updateVisibleDealerItems () {
      const startIndex = 0
      const endIndex = this.dealerCurrentPage * this.dealerItemsPerPage
      this.visibleDealerItems = this.filteredItems.slice(startIndex, endIndex)
    },

    loadMoreDealerItems () {
      if (this.dealerCurrentPage * this.dealerItemsPerPage >= this.filteredItems.length) return
      this.dealerCurrentPage++
      this.updateVisibleDealerItems()
    },

    handleDealerTableScroll (event) {
      const container = event.target
      const scrollBottom = container.scrollHeight - container.scrollTop - container.clientHeight
      if (scrollBottom < 100) {
        this.loadMoreDealerItems()
      }
    },

    getDealerVisibleItems (dealerId) {
      return this.dealerClientsData[dealerId] || []
    },

    updateDealerClientItems (dealerId) {
      const dealer = this.filteredDealers.find(d => d.id === dealerId)
      if (!dealer) return

      const clients = (this.filterOptions.searchFilter && dealer.filteredClients)
        ? dealer.filteredClients
        : dealer.clients

      if (!clients) return

      const currentPage = this.dealerClientsCurrentPages[dealerId] || 1
      const startIndex = 0
      const endIndex = currentPage * this.dealerClientsPerPage
      this.$set(this.dealerClientsData, dealerId, clients.slice(startIndex, endIndex))
    },

    loadMoreDealerClientItems (dealerId) {
      const dealer = this.filteredDealers.find(d => d.id === dealerId)
      if (!dealer) return

      const clients = (this.filterOptions.searchFilter && dealer.filteredClients)
        ? dealer.filteredClients
        : dealer.clients

      if (!clients) return

      const currentPage = this.dealerClientsCurrentPages[dealerId] || 1
      if (currentPage * this.dealerClientsPerPage >= clients.length) return

      this.$set(this.dealerClientsCurrentPages, dealerId, currentPage + 1)
      this.updateDealerClientItems(dealerId)
    },

    handleDealerClientScroll (event, dealerId) {
      const container = event.target
      const scrollBottom = container.scrollHeight - container.scrollTop - container.clientHeight
      if (scrollBottom < 100) {
        this.loadMoreDealerClientItems(dealerId)
      }
    },

    clearField () {
      this.filterOptions.searchFilter = null
      if (this.filterOptions.selectedDealer !== null) {
        this.updateVisibleDealerItems()
      } else {
        // При очистке поиска закрываем все карточки
        this.expandedDealers = {}
        this.applyDealerSearch()
      }
    },

    downloadActiveClientsWithoutOrgIdReport () {
      this.getActiveClientsWithoutOrgIdReport({
        month: this.selectedMonth,
        year: this.selectedYear
      })
    },

    isActiveClientWithoutOrgId () {
      return this.userInfo.rights?.includes('report_active_clients_without_orgid') || false
    },

    isProminvestUser () {
      return this.userInfo.rights?.includes('prominvest_report') || false
    },

    isPickUgUser () {
      return this.userInfo.rights?.includes('web_client_reports_pu') || false
    },

    setItems () {
      this.clearStatistic()
      this.loading = true
      this.disableButton = true
      this.loadSalesStatistic(this.dateForReport).finally(() => {
        this.loading = false
        this.disableButton = false
      })
      this.filterOptions.selectedDealer = null
    },

    downloadXlsxClientProgram (id, name) {
      this.loadDealerReportProminvestXlsx({
        date: this.dateForReport,
        dealerId: id,
        dealerName: name
      })
    },

    downloadXlsx (id, name) {
      if (!id) {
        const dealers = [...new Set(this.filteredItems.map(item => +item.dealer_org_id))].filter(Boolean)
        const clients = [...new Set(this.filteredItems.map(item => +item.client_org_id))].filter(Boolean)
        if (clients.length === 0 && dealers.length === 0) {
          alert('Нет данных для загрузки')
          return
        }
        this.loadDealerReportFilteredXlsx({
          date: this.dateForReport,
          dealers,
          clients,
          dealerName: ''
        })
      } else {
        this.loadDealerReportFilteredXlsx({
          date: this.dateForReport,
          dealers: [+id],
          clients: [],
          dealerName: name
        })
      }
    },

    downloadXml () {
      this.loadDealerReportXml(this.dateForReport)
    },

    changeDateStart (value) {
      if (value) {
        const date = value.toDate()
        this.dateForReport.dateStart = date.getFullYear() * 12 + (date.getMonth() + 1)
        this.dateForReport.dateString = `${date.getMonth() + 1}_${date.getFullYear()}`
        this.selectedMonth = date.getMonth() + 1
        this.selectedYear = date.getFullYear()
      } else {
        this.dateForReport.dateStart = null
        this.dateForReport.dateString = null
        this.selectedMonth = null
        this.selectedYear = null
      }
    },

    changeDateEnd (value) {
      if (value) {
        const date = value.toDate()
        this.dateForReport.dateEnd = date.getFullYear() * 12 + (date.getMonth() + 1)
      } else {
        this.dateForReport.dateEnd = null
      }
    },

    ...mapActions('statistic', [
      'loadDealerReportXlsx',
      'loadDealerReportFilteredXlsx',
      'loadSalesStatistic',
      'loadDealerReportXml',
      'loadDealerReportProminvestXlsx',
      'getActiveClientsWithoutOrgIdReport'
    ]),

    ...mapMutations('statistic', [
      'clearStatistic'
    ])
  }
}
</script>

<style scoped lang="scss">
  .virtual-table-container {
    max-height: 600px !important;
    overflow-y: auto;
    border: 1px solid #dee2e6;
  }

  .loading-more {
    text-align: center;
    padding: 15px;
    background: #f8f9fa;
    border-top: 1px solid #dee2e6;
  }

  .table thead th {
    min-width: 80px;
  }

  select {
    cursor: pointer;
  }

  .button-end {
    display: flex;
    justify-content: flex-end;
  }

  .download-report {
    display: flex;
    justify-content: space-between;
    align-items: center;
    i {
      color: #6c6c6c;
    }
  }

  ul {
    margin-bottom: 0;
    padding-left: 0;
    li.positions-elements {
      list-style: none;
      border-bottom: 1px solid #dadada;
      padding: 10px;
    }
  }

  p.total {
    font-weight: 400;
    font-size: 18px;
    color: #6c6c6c;
    margin-bottom: 0;
  }
  .total {
    font-weight: 600;
    color: black;
    margin-bottom: 0;
  }
  p.info-text {
    font-size: 14px;
    margin-bottom: 0;
  }

  .container_search-close {
    position: absolute;
    right: 35px;
    top: 21px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    z-index: 4;
    &:hover {
      border-radius: 50%;
      background-color: #acacac;
    }
    .search-close {
      font-size: 18px;
      color: #acacac;
      cursor: pointer;
      line-height: 18px;
      width: 20px;
      text-align: center;
      margin-bottom: 2px;
      &:hover {
        color: #fff;
      }
    }
  }
  @media screen and (max-width: 1024px) {
    p.info-text {
      font-size: 12px;
      margin-bottom: 0;
    }
  }
  .monthColumn {
    vertical-align: middle;
    text-align: center;
  }
  .dealer-clients {
    margin-bottom: 0 !important;
  }

  .card-expanded {
    border: 2px solid #007bff !important;
    box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3) !important;
  }

  .b-card {
    transition: all 0.3s ease;
    &:hover {
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
      transform: translateY(-2px);
    }
  }
</style>
